import React, { useCallback, useEffect, useState } from "react"

import { openNavigationEvent } from "./ClientBurgerButton"

interface NavigationItem {
  name: string
  url: string
}

interface SideProps {
  items: NavigationItem[]
  client_site_root: string
  partner_image_src: string
}

const ClientSideNavigation = ({ items, client_site_root, partner_image_src }: SideProps) => {
  const [showOverlay, setShowOverlay] = useState(false)
  
  const closeSideNavigation = useCallback(() => {
    setShowOverlay(false)
  }, [])

  const openSideNavigation = useCallback(() => {
    setShowOverlay(true)
  }, [])

  useEffect(() => {
    document.addEventListener(openNavigationEvent.type, openSideNavigation)

    return () => {
      document.removeEventListener(openNavigationEvent.type, openSideNavigation)
    }
  }, [openSideNavigation])
  
  return (
    <>
      <div className={showOverlay ? "sideNavigation sideNavigation--open" : "sideNavigation"}>
        <div className="sideNavigation__sideHeader">
          <div className="sideNavigation__back" onClick={closeSideNavigation} />
          <a href={client_site_root}>
            <img src={partner_image_src} width="98" height="48" />
          </a>
        </div>
        <ul className="sideNavigation__list">
          {items.map((item) => {
            return <li key={item.name} className="sideNavigation__list__item">
              <a className="sideNavigation__navLink" href={item.url}>
                {item.name}
              </a>
            </li>
          })}
        </ul>
        <div className="sideNavigation__sideFooter">
          <a
            className="sideNavigation__sideFooter__logo sideNavigation__sideFooter__logo--penny"
            href="https://www.penny.de/eishockey"
            target="_blank"
          />
          <a
            className="sideNavigation__sideFooter__logo sideNavigation__sideFooter__logo--nikon"
            href="https://www.nikon.de/"
            target="_blank"
          />
        </div>
      </div>
      {showOverlay && <div className="sideNavigationPageOverlay" />}
    </>
  )
}

export default ClientSideNavigation
